const PersonalDetails = ({ data }) => (
  <div className="form-body">
    <ul
      style={{
        listStyle: "none",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "20px 0px",
      }}
    >
      <li>
        <ul>
          <li>Name</li>

          <li>Date Of Birth</li>
          <li>Gender</li>
          <li>Nationality</li>
          <li>Aadhar No.</li>
          <li>Email</li>
          <li>Unique ID No.</li>

          {/* {data.urn === "" ? "" : <li>Enrollment No.</li>} */}
          <li>UP Residence</li>
          <li>Category</li>
          {data.category !== "GENERAL" && <>
            <li>Subcategory</li>
            <li>Category Certificate Number</li>
            <li>Category Issue Date</li>
          </>}
          <li>Father Name</li>

          <li>Father Occupation</li>

          <li>Mother Name</li>

          <li>Mother Occupation</li>
          <li>Marital Status</li>
           <li>Phone Number</li>
            <li>Whatsapp Number</li>

          <li style={{ fontWeight: "600" }}>Address</li>
          <li>Village / Mohalla</li>
          <li>Post</li>
          <li>Tehsil</li>
          <li>District</li>
          <li>PinCode</li>

         
          {/* <li>Whatspp No.</li> */}
        </ul>
      </li>
      <li>
        <b>
          <ul>
            <li  style={{ textTransform: "capitalize" }}>{data.applicant_name || "N/A"}</li>
            <li>{data.dob || "N/A"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.gender ===  "M" ? "Male" : (data.gender == "F" ? "Female": (data.gender === "O" && "Other") )}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.religion || "Indian"}</li>
            <li>{data.aadhar || "N/A"}</li>
            <li>{` ${data.applicant_email.toLowerCase()}` || "N/A"}</li>

            {data.urn === "" ? "" : <li>{data.urn || "N/A"}</li>}
            {/* <li>{data.id || "N/A"}</li> */}

            <li>{data.same_state==1?"Yes":"No"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.category || "N/A"}</li>
            {data.category !== "GENERAL" && <>
              <li style={{ textTransform: "capitalize" }}>{data.subcategory || "NA"}</li>
              <li>{data.caste_certificate_number || "NA"}</li>
              
              <li>{data.category_issue_date || "."}</li>
            </>}
            <li  style={{ textTransform: "capitalize" }}>{data.father_name || "N/A"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.father_occupation || "N/A"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.mother_name || "N/A"}</li>
            <li>{data.mother_occupation || "N/A"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.marital_status || "N/A"}</li>
                <li>{`+91-${data.applicant_mobile}` || "N/A"}</li>
                  <li>{`+91-${data.whatsapp_number }`|| "Caste Number"}</li>
            <li>.</li>
         

            <li  style={{ textTransform: "capitalize" }}>{data.permanent_address_village_mohalla || "N/A"}</li>
            <li  style={{ textTransform: "capitalize" }}>{data.permanent_address_post || "N/A"}</li>
            <li style={{ textTransform: "capitalize" }}>{data.permanent_address_tehsil || "N/A"}</li>
            <li style={{ textTransform: "capitalize" }}>{data.permanent_address_district || "N/A"}</li>
            <li>{data.permanent_address_pincode || "N/A"}</li>

           
            {/* <li>{data.whatsapp_number || "N/A"}</li> */}
          </ul>
        </b>
      </li>
      <li style={{ paddingInlineEnd: "10px" }}>
        <div>
          <img
            src={`${data.image_file}`}
            style={{ height: "150px", width: "100px" }}
            alt="Applicant"
          />
        </div>
        <div>
          {/* <img 
            src={`https://campus.acetians.in/custom/uploads/${data.signature_file}`} 
            style={{ width: '100px', height: 'auto' }} 
            alt="Signature"
          /> */}
        </div>
      </li>
    </ul>
  </div>
);

export default PersonalDetails;
